import { REQUEST_FAQ, RECEIVE_FAQ, FAILURE_FAQ } from './constants';
import { CALL_API } from '../../middlewares/api';
import _ from 'lodash';

export function fetchFaqIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/faq',
            types: [REQUEST_FAQ, RECEIVE_FAQ, FAILURE_FAQ],
            shouldCallAPI: state => shouldFetchFaq(state)
        }
    };
}

function shouldFetchFaq(state) {
    const faqs = state.faq.faqs;
    const fetching = state.faq.fetching;

    if (fetching) {
        return false;
    } else if (_.isEmpty(faqs)) {
        return true;
    } else {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/services/faq/actions.js